import { UserGuideType } from 'v2/constants';
import { SelectOption } from 'v2/types';
import { UserGuideModel } from 'v2/types/UserGuideModel';
import { enumToSelect } from 'v2/utils';

export type UserGuideForm = Omit<UserGuideModel, 'id'>;

export const initialValues: UserGuideForm = {
  key: '',
  type: UserGuideType.INTRO,
  reward: 0,
  isDefault: false,
};

export const options: SelectOption<UserGuideType>[] = enumToSelect(UserGuideType);
